
import { Fragment } from 'vue-frag'

export default {
  name: 'Organism3DContainer',
  components: {Fragment},
  props: {
    containerData: {
      required: true,
      type: Object || Array,
      default: function () {
        return {
          backgroundLoader: '',
          contentLoader: [],
          videosLoader: []
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    backgroundLoaderUrl() {
      return this.containerData?.backgroundLoader
    },
    contentLoaderData() {
      return this.containerData?.contentLoader || []
    },
    videosLoader() {
      return this.containerData?.videosLoader || []
    },
    loadingErrorOccurred() {
      return this.$store.state.building.loadingErrorOccurred
    },
    generalConfig() {
      return this.$store.state.base.meta.generalConfig
    },
    hasMatterport() {
      return this.generalConfig.matterportEnabled
    },
    shouldNotInitiate() {
      const {path} = this.$route;
      return this.hasMatterport && path.includes('/space/')
    }
  },
  mounted() {},
  methods: {}
}
